<template>
  <form class="md:p-8" @submit.prevent="submit">
    <div class="vx-card__title">
      <h4 class="mt-6 md:mt-0 pb-4">
        {{ type === "HISTORY" ? "Historie" : "Wiedervorlage" }}
      </h4>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <DataInput
          v-model="value.consultantID"
          :initial-value="value.consultant"
          type="model"
          class="w-full mt-4"
          label="Für Berater"
          name="consultantID"
          model-label="
            firstName
            lastName"
          :select-label="el => el.firstName + ' ' + el.lastName"
          gql-query="consultantsPage"
          gql-single-query="consultant"
          gql-filter-type="objectFilter"
          @input="x => update('consultantID', x)"
        />
      </div>
      <div class="vx-col w-full md:w-1/2">
        <DataInput
          v-model="value.typeID"
          :initial-value="value.type"
          type="model"
          class="w-full mt-4"
          label="Art"
          name="typeID"
          :model-label="
            type == 'RESUBMISSION' ? 'nameResubmission' : 'nameHistory'
          "
          :select-label="
            type == 'RESUBMISSION' ? 'nameResubmission' : 'nameHistory'
          "
          gql-query="actionTypes"
          @input="x => update('typeID', x)"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <DataInput
          v-model="value.dueAt"
          type="date"
          class="w-full mt-4"
          label="Datum"
          name="dueAt"
          :config="{
            altFormat: 'd.m.Y H:i',
            dateFormat: 'Y-m-d H:i',
            enableTime: true,
            time_24hr: true
          }"
          @input="x => update('dueAt', x)"
        />
      </div>
    </div>
    <div v-if="type == 'RESUBMISSION'" class="vx-row">
      <div class="vx-col w-full md:w-1/3">
        <DataInput
          v-model="reminder"
          type="bool"
          class="w-full mt-4"
          label="Erinnerung aktivieren"
          name="reminder"
          @input="toggleReminder"
        />
      </div>
      <div v-if="reminder" class="vx-col w-full md:w-2/3">
        <DataInput
          v-model="value.remindAt"
          type="date"
          class="w-full mt-4"
          label="Erinnerung am"
          name="remindDate"
          :config="{
            altFormat: 'd.m.Y H:i',
            dateFormat: 'Y-m-d H:i',
            enableTime: true,
            time_24hr: true
          }"
          @input="x => update('remindAt', x)"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <DataInput
          v-model="value.projectID"
          :initial-value="value.project"
          type="model"
          class="w-full mt-4"
          label="Stelle"
          name="job"
          model-label="title
                        number"
          :select-label="el => '[' + el.number + '] ' + el.title"
          gql-query="vacancyProjectPage"
          gql-filter-type="objectFilter"
          object-filter-attribute="searchQuery"
          @input="x => update('projectID', x)"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <DataInput
          v-model="value.title"
          class="w-full mt-4"
          label="Betreff"
          name="title"
          @input="x => update('title', x)"
        />
      </div>
      <div class="vx-col w-full">
        <DataInput
          v-model="value.description"
          required
          type="html"
          class="w-full mt-4"
          label="Beschreibung"
          name="description"
          @input="x => update('description', x)"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button class="mt-4" @click="submit"
          >{{
            type === "HISTORY" ? "Historie" : "Wiedervorlage"
          }}
          anlegen</vs-button
        >
      </div>
    </div>
  </form>
</template>

<script>
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  props: {
    type: {
      type: String,
      default: "HISTORY"
    },
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    reminder: true
  }),
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  watch: {
    "value.remindAt": {
      immediate: true,
      handler(v) {
        this.reminder = !!v;
      }
    }
  },
  methods: {
    submit() {
      this.$emit("submit", this.internalValue);
    },
    toggleReminder() {
      if (!this.reminder) {
        this.internalValue.remindAt = null;
      }
    },
    update(key, value) {
      this.$emit("input", { ...this.value, ...{ [key]: value } });
    }
  }
};
</script>
